export const TKeyApp = {
  APP_TITLE: "APP_TITLE",
  APP_DESCRIPTION: "APP_DESCRIPTION",
  APP_KEYWORDS: "APP_KEYWORDS",
  WELCOME_TO_MEIDLY: "WELCOME_TO_MEIDLY",
  WELCOME_EMOJI: "WELCOME_EMOJI",
  HOME_CTA_BOOK_DEMO: "HOME_CTA_BOOK_DEMO",
  HOME_CTA_START_FREE: "HOME_CTA_START_FREE",
} as const;
